import { useEffect, useRef, type MutableRefObject } from 'react';

/**
 * Onda del microfono: barras que siguen el nivel de la voz del usuario.
 *
 * Lee el nivel por referencia y pinta en un bucle propio, sin estado de
 * React: a sesenta fotogramas por segundo, cualquier otra via repintaria toda
 * la pagina.
 */
export function MicMeter({ levelRef, active }: { levelRef: MutableRefObject<number>; active: boolean }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const bars = Array.from(el.children) as HTMLElement[];
    const history = new Array<number>(bars.length).fill(0);
    let frame = 0;
    let t = 0;
    const tick = () => {
      t += 1;
      if (t % 3 === 0) {
        history.shift();
        history.push(active ? levelRef.current : 0.15 + 0.1 * Math.sin(t / 6));
      }
      bars.forEach((bar, i) => {
        const v = Math.max(0.12, Math.min(1, history[i]! * 1.4));
        bar.style.transform = `scaleY(${v.toFixed(3)})`;
      });
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [active, levelRef]);

  return (
    <div className="meter" ref={ref} aria-hidden="true">
      {Array.from({ length: 18 }, (_, i) => (
        <i key={i} />
      ))}
    </div>
  );
}
